goog.provide("shadow.js.shim.module$react_bootstrap$OverlayTrigger$default");
shadow.js.shim.module$react_bootstrap$OverlayTrigger$default = shadow.js.require(209, {})["default"];
